<template>
  <el-form
    ref="actFormData"
    :model="actFormData"
    :rules="rules"
    :label-position="isMobile ? 'top' : 'right'"
    label-width="130px"
    class="act-body"
  >
    <el-container>
      <el-aside width="280px">
        <el-row>
          <upload-img
            :img="imgUrl"
            :loading="loading"
            :types="types"
            @changed="handleFile"
            @delete="$emit('delete')"
          />
        </el-row>
        <el-row class="mr-20 print-box">
          <span v-if="showNdsStatus" class="title green">
            Контрагент {{ ndsStatuses[ttnData.nds_status].text }}
          </span>
          <template v-else>
            <span class="title">
              Распечатать акт
              <span v-if="performerName">{{ performerName }}</span>
            </span>
            <el-button
              :loading="loading"
              :disabled="!performerName"
              type="primary"
              class="print-act"
              @click="downloadReportAct('akt')"
            >
              Excel
            </el-button>
            <el-button
              :loading="loading"
              :disabled="!performerName"
              type="primary"
              class="print-act"
              @click="downloadReportAct('akt', { as_pdf: 1 })"
            >
              PDF
            </el-button>
            <el-button
              v-if="performerId === 13815"
              :loading="loading"
              :disabled="!performerName"
              type="primary"
              class="print-act"
              @click="downloadReportAct('akt', { with_sign: 1 })"
            >
              PDF с печатью
            </el-button>
            <span v-if="!performerName" class="redColor fs-10">
              Необходимо
              <choose-performer
                :id="bidId"
                :update-id="responseId"
                @update="handlerUpdate"
              >
                <span class="cp td-u"> указать исполнителя перевозки </span>
              </choose-performer>
            </span>
          </template>
        </el-row>
        <el-row class="mr-20">
          <el-button
            type="primary"
            class="print-act"
            :loading="loading"
            @click="downloadReportAct('p-akt')"
          >
            Распечатать перевыставленный акт
          </el-button>
        </el-row>
        <slot />
      </el-aside>
      <el-main class="act-main">
        <el-form-item prop="number" label="№ АКТА:">
          <el-input
            ref="input-act-number"
            v-model="actFormData.number"
            placeholder="№ АКТА"
          />
        </el-form-item>
        <el-form-item>
          <el-link type="success" @click="onActNumberHandler">
            Номер акта
          </el-link>
        </el-form-item>
        <el-form-item prop="document_create_date" label="Дата:">
          <el-date-picker
            v-model="actFormData.document_create_date"
            type="date"
            placeholder="Выберите дату"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="Акт на сумму:">
          <el-input :value="responseCostAmount" readonly placeholder="0" />
        </el-form-item>
        <el-form-item label="Сумма недовоза:">
          <el-input :value="responseDeficiencyCost" readonly placeholder="0" />
          <el-button
            v-if="responseDeficiencyCost > 0"
            type="text"
            @click="downloadReportAct('akt-nedovoz')"
          >
            Скачать акт недовоза
          </el-button>
        </el-form-item>
        <el-checkbox v-model="hasIdle" @change="toggleIdle">
          Простой
        </el-checkbox>
        <el-collapse-transition>
          <div v-if="hasIdle">
            <el-form-item
              ref="idle_price"
              prop="idle_price"
              label="Цена простоя:"
            >
              <el-input
                v-model="actFormData.idle_price"
                type="number"
                placeholder="0"
                class="idle__input"
                @focus="$refs.idle_price.clearValidate()"
              />
            </el-form-item>
            <el-form-item ref="idle" prop="idle" label="Суток простоя:">
              <el-input
                v-model="actFormData.idle"
                type="number"
                placeholder="0"
                class="idle__input"
                @focus="$refs.idle.clearValidate()"
              />
            </el-form-item>
          </div>
        </el-collapse-transition>

        <el-form-item style="text-align: right" class="confirmation__button">
          <el-button
            type="primary"
            :loading="loading"
            @click="saveAct('actFormData')"
          >
            Сохранить
          </el-button>
        </el-form-item>
        <template v-if="isSigned">
          <el-row
            v-for="key in arrSigned"
            :key="key"
            type="flex"
            class="act-signed"
          >
            <p>{{ key }}:</p>
            <div class="sign-info">
              {{ isSigned[key] }}
            </div>
          </el-row>
        </template>
        <el-row
          v-if="ttnData.nopaper_contragent || nopaperChecked"
          class="nopaper"
        >
          <span>
            <img
              style="width: 100px"
              src="@/assets/img/nopaper-icon.png"
              alt=""
            />
          </span>
          <el-button
            v-if="showSendActBtn"
            type="primary"
            plain
            size="small"
            :loading="loading"
            @click="$emit('nopaper')"
          >
            Отправить акт
          </el-button>
          <el-row
            v-if="ttnData.nopaper_document_exist"
            type="flex"
            class="fd-column nopaper__info"
          >
            <span>
              Статус:
              <b
                :class="{ green: ttnData.nopaper_act_status === 'nopaperEnd' }"
              >
                {{ NO_PAPER_STATUSES[ttnData.nopaper_act_status] || '-' }}
              </b>
            </span>
            <span>
              Дата:
              <b>
                {{ getDateOfCertainFormat(ttnData.nopaper_date) || '-' }}
              </b>
            </span>
          </el-row>
        </el-row>
        <el-row v-else class="nopaper">
          <el-button
            type="warning"
            plain
            size="medium"
            :loading="loader"
            @click="checkClientNopaper"
          >
            Проверить в NoPaper
          </el-button>
        </el-row>
      </el-main>
    </el-container>
  </el-form>
</template>

<script>
import { NO_PAPER_STATUSES } from '@/components/Forms/constants'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { ndsStatusConfig } from '@/components/Shared/constants'
import { pickerOptions } from '@/datas/consts'
import ChoosePerformer from '@/components/Modals/ChoosePerformer'
import UploadImg from '@/components/Upload/UploadImg'

const Doc = RepositoryFactory.get('doc')
const NoPaperAPI = RepositoryFactory.get('noPaper')

export default {
  name: 'FormActs',
  components: { UploadImg, ChoosePerformer },
  props: {
    responseId: {
      type: Number,
      required: true,
    },
    actNumber: {
      type: Number,
      required: true,
    },
    bidId: {
      type: Number,
      required: true,
    },
    responseDeficiencyCost: {
      type: Number,
      required: true,
    },
    responseCostAmount: {
      type: Number,
      required: true,
    },
    responseIdle: {
      type: [Number, String],
      default: null,
    },
    responseIdlePrice: {
      type: [Number, String],
      default: null,
    },
    performerName: {
      type: String,
      default: '',
    },
    performerId: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    activeAct: {
      type: Object,
      default: () => null,
    },
    ttnData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      NO_PAPER_STATUSES,
      actFormData: {
        number: '',
        document_create_date: '',
        file: '',
        // поля для простоя
        idle_price: null,
        idle: null,
      },
      hasIdle: false,
      imgUrl: '',
      rules: {
        number: [
          { required: true, message: 'Заполните № АКТ', trigger: 'blur' },
        ],
        document_create_date: [
          { required: true, message: 'Укажите дату', trigger: 'blur' },
        ],
        idle_price: [
          {
            required: true,
            message: 'Укажите цену простоя',
            trigger: 'submit',
          },
        ],
        idle: [
          {
            required: true,
            message: 'Укажите длительность простоя в сутках',
            trigger: 'submit',
          },
        ],
      },
      types: {
        format: ['application/pdf'],
        title: '/pdf',
      },
      arrSigned: [
        'transaction_id',
        'confirm_code',
        'confirm_code_created_at',
        'signature',
      ],
      pickerOptions: {
        ...pickerOptions,
        disabledDate: null,
      },
      nopaperChecked: false, // когда проверка на NoPaper делается из модалки
      loader: false, // индикация загрузки на кнопке проверки
      ndsStatuses: ndsStatusConfig,
    }
  },
  computed: {
    isSigned() {
      let res = null

      if (
        this.activeAct &&
        this.activeAct.pc_api_transactions &&
        this.activeAct.pc_api_transactions.length
      ) {
        res = this.activeAct.pc_api_transactions[0]
        res.confirm_code_created_at = this.getDateOfCertainFormat(
          res.confirm_code_created_at,
        )
      }

      return res
    },
    showSendActBtn() {
      return (
        (!this.ttnData.nopaper_document_exist &&
          this.activeAct?.number &&
          this.activeAct?.document_create_date) ||
        this.ttnData.nopaper_act_status === 'nopaperEnd'
      )
    },
    // отображаем НДС только в том случае, если клиент с НДС
    showNdsStatus() {
      return !['not_stated', 'not_used'].includes(this.ttnData.nds_status)
    },
  },
  watch: {
    activeAct: {
      immediate: true,
      handler(val) {
        if (val && val.id) {
          this.actFormData.document_create_date = val.document_create_date
          this.actFormData.number = val.number
          this.imgUrl = val.files && val.files.length ? val.files[0].link : ''
        }
      },
    },
  },
  created() {
    if (this.responseIdle) {
      this.hasIdle = true
      this.actFormData.idle_price = this.responseIdlePrice
      this.actFormData.idle = this.responseIdle
    }
  },
  methods: {
    downloadReportAct(val, params = {}) {
      if (this.responseId) {
        this.downloadRegistry({
          path: Doc.getActReport(
            { response_id: this.responseId, ...params },
            val,
          ),
          blank: 1,
        })
      } else {
        this.$message.warning('Не выбран ни один акт')
      }
    },
    handlerUpdate(obj) {
      this.$emit('set', obj)
    },
    toggleIdle() {
      if (!this.hasIdle) {
        this.$confirm(
          'Вы уверены, что хотите удалить информацию по простою?',
          'Подтверждение операции',
          {
            confirmButtonText: 'Да',
            cancelButtonText: 'Отмена',
            type: 'warning',
          },
        )
          .then(() => {
            this.actFormData.idle = null
            this.actFormData.idle_price = null
          })
          .catch(() => {
            this.hasIdle = true
          })
      }
    },
    saveAct(formName) {
      this[formName].number = this[formName].number.toString()

      if (this.activeAct && this.activeAct.id) {
        this.updateAct(formName)
      } else {
        this.createAct(formName)
      }
    },
    createAct(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit('save', this.actFormData)
        }
      })
    },
    updateAct(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$emit('update', {
            ...this.actFormData,
            id: this.activeAct.id,
          })
        }
      })
    },
    handleFile(file) {
      this.actFormData.file = file
    },
    onActNumberHandler() {
      this.actFormData.number = this.actNumber.toString()
    },
    checkClientNopaper() {
      this.loader = true
      NoPaperAPI.checkNopaper({ contragent_inn: this.ttnData.auto.carrier_inn })
        .then(() => (this.nopaperChecked = true))
        .catch(err => {
          if (err.response && err.response.status === 422) {
            err.response.data =
              'Контрагент не зарегистрирован в системе NoPaper'
          } else {
            err.data.errors =
              err.data.name && err.data.name === 'Not Found'
                ? 'Контрагент не зарегистрирован в системе NoPaper'
                : 'Система NoPaper недоступна, повторите запрос позднее'
            err.status = 422
          }
          this.errHandler(err)
        })
        .finally(() => (this.loader = false))
    },
  },
}
</script>

<style lang="sass">
.act-body
  .mr-20
    margin-right: 20px
  .el-upload
    width: 100% !important
    .el-button
      width: 100% !important
  .upload-img .el-upload-list--picture-card .el-upload-list__item
    width: 100%
  .fs-10
    font-size: 10px
  .print-act
    width: 100%
    margin-top: 15px
    font-size: 12px
  .act-main
    padding: 0 20px
    position: relative
  .act-signed
    font-size: 14px
    margin-bottom: 10px
    p
      font-weight: bold
      margin: 0
      width: 200px
    div
      width: -webkit-calc(100% - 190px)
      width: -moz-calc(100% - 190px)
      width: calc(100% - 190px)
  .el-aside
    .print-box
      border: 2px dashed #606266
      padding: 5px 10px 10px
      margin-top: 10px
      .title
        font-size: 14px
        color: #606266
        &.green
          color: #589839
      .el-button
        margin-right: 10px
      .el-button+.el-button
        margin-left: 0
  .nopaper
    position: absolute
    bottom: 0
    right: 0
    display: flex
    flex-direction: column
    align-items: flex-end
    &__info
      font-size: 14px
      line-height: 22px
    .green
      color: #589839

.idle__input
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button
    -webkit-appearance: none
    margin: 0
  input[type=number]
    -moz-appearance: textfield

.confirmation__button
  margin-bottom: 100px
</style>
